import React, { memo } from 'react';

export const ParagraphIcon = memo(() => (
  <div className="flex flex-col gap-1.5 w-12">
    <div className="h-[3px] bg-white/15 rounded-sm w-full" />
    <div className="h-[3px] bg-white/15 rounded-sm w-full" />
    <div className="h-[3px] bg-white/15 rounded-sm w-full" />
    <div className="h-[3px] bg-white/15 rounded-sm w-[60%]" />
  </div>
));
